// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomCheckbox_wrapper__co0sU","noClickable":"CustomCheckbox_noClickable__KqG4k"};